import { Lock } from 'lucide-react'

/**
 * ForbiddenState — permissão negada NÃO é falha (#425). Tom neutro, sem
 * `role="alert"`, sem vermelho: quem lia a caixa de erro do `ErrorState` num
 * 403 entendia "o sistema quebrou" e abria chamado.
 *
 * A mensagem é a MESMA para "não tem acesso" e "não existe", e não diz qual
 * permissão falta — senão a tela vira sonda de descoberta de recurso.
 *
 * Arquivo próprio (#828): o guard de rota vive no bundle inicial, e importar
 * de `ui.tsx` arrastava Tooltip, Card e ícones que só as telas usam.
 */
export function ForbiddenState({
  title = 'Você não tem acesso a esta área',
  description = 'Fale com o gestor da sua cooperativa se precisar deste acesso.',
}: {
  title?: string
  description?: string
} = {}) {
  return (
    <div className="flex flex-col items-center gap-2 rounded-lg border border-dashed border-gray-200 p-8 text-center dark:border-gray-800">
      <Lock className="h-6 w-6 text-gray-400" aria-hidden="true" />
      <p className="text-sm font-medium text-gray-700 dark:text-gray-300">{title}</p>
      <p className="text-sm text-gray-500 dark:text-gray-400">{description}</p>
    </div>
  )
}
